module.exports = __webpack_public_path__ + "static/media/helloworld.1f699f5c.png";